/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationDetails {
    getFixupPrototypeFunction() { return RecommendationDetails.fixupPrototype; }

    static newInstance(model: Partial<RecommendationDetails>): RecommendationDetails {
        let obj = Object.assign(new RecommendationDetails(), model);
        RecommendationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationDetails>): RecommendationDetails {
        if (!model) return null;
        return RecommendationDetails.newInstance(<RecommendationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationDetails) {
        if (!obj) return;

        models.RecommendationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationDetails): boolean {
        Object.setPrototypeOf(obj, RecommendationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the recommendation
     */
    name: string;

    /**
     * Recommendation tenant ID
     */
    tenant_id: string;

    /**
     * Recommendation service account ID
     */
    service_account_id: string;

    /**
     * List of policy IDs for which the recommendation is generated
     */
    policy_ids: Array<string>;

    /**
     * Policy Classification
     */
    policy_classification: models.PolicyClassification;

    /**
     * Policy Sub Classification
     */
    policy_sub_classification: models.PolicySubClassification;

    /**
     * Source of the recommendation
     */
    recommendation_source: models.RecommendationSource;

    /**
     * Impact of the recommendation
     */
    impact: models.PolicyResourceRecommendationImpact;

    /**
     * Status of the recommendation
     */
    status: models.PolicyResourceRecommendationStatus;

    /**
     * Description of the recommendation
     */
    recommendation_description: string;

}
